<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div fxFlex>
    <form [formGroup]="form"> 
      <mat-form-field class="width-100">
        <input 
          matInput
          #companyInput
          formControlName="company" 
          [matAutocomplete]="companyAC" 
          [placeholder]="'LABEL_COMPANY' | translate"
          (focus)="!companyAC.isOpen && getInitialValues('company')" 
          (blur)="checkAutocompleteObject(form, 'company')"
          [required]="isRequired"
          >

        <mat-icon 
          id="id_select_company_delete_btn"
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          (click)="companyInput.blur(); clearForm($event)"
          *ngIf="companyInput.value && !disabled"
          >
        </mat-icon>

        <mat-icon 
          matSuffix 
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!companyInput.value && !disabled"
          >
        </mat-icon>

        <mat-autocomplete 
          id="id_select_company_dropdown"
          [displayWith]="displayFn" 
          #companyAC="matAutocomplete" 
          (closed)="autoCmpltClosed(); companyInput.blur()"
          (opened)="autocompleteScroll('company','companyACRef','companyACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.company && listData?.length == 0"
            >
            {{ 'LABEL_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [id]="'id_select_company_data_' + (i+1)"
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData; let i = index" 
            [matTooltip]="data.code + ' - ' + data.description"
            >
            {{ data.code }} - {{ data.description }}
          </mat-option>

          <mat-option *ngIf="loading.company" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('company').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="form.get('company').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_COMPANY' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>